<template>
  <div>
    <div class="home-detail" id="package-detail" v-if="activeHomeDetail">
      <div class="header-bar">
        <div class="back-box">
          <a class="button app-accent" @click="goBack">BACK TO LIST</a>
          <a class="button app-primary pulse" @click="goToNext()">CONFIRM SELECTION</a>
        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline is-variable is-6 boxes">
          <div class="column is-6-desktop is-12-tablet is-12-mobile grid-box">
            <div class="facade-box box">
              <img :src="activeHomeDetail.facadelist[0].imageurl" alt="Placeholder image">
              <div class="columns package-detail is-gapless">
                <div class="column">
                  <p class="product">
                    {{ activeHomeDetail.designproductname }} {{ activeHomeDetail.facadeproductname }}
                  </p>
                  <p class="builder-name">
                    {{ activeHomeDetail.ownername }}
                  </p>
                </div>
                <div class="column is-narrow has-text-right">
                  <div>

                  </div>
                  <div class="amenities ml-0">
                    <div class="amenity">
                      <img :src="require('@/assets/icons/bed.svg')" alt="">
                      <span>{{ activeHomeDetail.noofbedrooms }}</span>
                    </div>
                    <div class="amenity">
                      <img :src="require('@/assets/icons/bath.svg')" alt="">
                      <span>{{ activeHomeDetail.noofbathrooms }}</span>
                    </div>
                    <div class="amenity">
                      <img :src="require('@/assets/icons/car.svg')" alt="">
                      <span>{{ activeHomeDetail.noofcarparks }}</span>
                    </div>
                  </div>
                  <p class="price">
                    <span class="from">From</span>
                    ${{ activeHomeDetail.productprice.toLocaleString() }}
                  </p>
                </div>
              </div>
            </div>

            <div class="box">
              <div class="lot-fit-dimensions">
                <div class="box-header">
                  <p class="s-title">
                    Dimensions
                  </p>
                </div>

                <div class="box-body">
                  <div class="columns is-multiline">
                    <div class="column is-6">
                      <p class="dim-title">Square Footage</p>
                      <p class="dim">{{ activeHomeDetail.productsize.toLocaleString() }}
                        <small> sq ft</small></p>
                    </div>
                    <div class="column is-6">
                      <p class="dim-title">Home Width</p>
                      <p class="dim">{{Math.floor(activeHomeDetail.productwidth/12)}} <small>ft</small> </p>
                    </div>
<!--                    <div class="column is-6">-->
<!--                      <p class="dim-title">Home Depth</p>-->
<!--                      <p class="dim">{{ activeHomeDetail.productdeptch }}</p>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-6-desktop is-12-tablet is-12-mobile grid-box">
            <div class="box">
              <div class="floorplan-section">
                <a :href="activeHomeDetail.imagepath" data-lightbox="floorplan"
                   data-title="Floorplan">
                  <img :src="activeHomeDetail.imagepath">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-similar-homes v-bind:activeHomeDetail="activeHomeDetail"
                         v-on:similarhome="replaceActiveDetail($event)"></app-similar-homes>
    </div>
  </div>
</template>

<script>
import SimilarHomes from "@/components/journey/home/SimilarHomes";

export default {
  name: 'home-detail',
  props: {
    activeHomeDetail: {
      type: Object
    }
  },
  components: {
    'app-similar-homes': SimilarHomes
  },
  data() {
    return {
      showDetail: false
    }
  },
  watch: {
    activeHomeDetail(val, oldval) {
      if (val) {
        this.showDetail = true
      }
    }
  },
  methods: {
    goBack: function () {
      this.showDetail = false;
      this.$emit('close-detail')
    },

    replaceActiveDetail: function (homeSummary) {
      for (let key in this.activeHomeDetail) {
        this.activeHomeDetail[key] = homeSummary[key];
      }
    },

    goToNext: function () {
      let lotid;
      let lotcpid;
      const query = this.$route.query;
      if (query.lotid) {
        lotid = query.lotid;
      }
      if (query.lotcpid) {
        lotcpid = query.lotcpid;
      }
      console.log(this.activeHomeDetail)
      this.$router.push({
        path: '/community/facade',
        query: {
          homeid: this.activeHomeDetail.cpidstring,
          lotid: lotid,
          lotcpid: lotcpid,
          plancpid: this.activeHomeDetail.planProductCpIdString
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/home/HomeDetail.vue